import { Toggle } from '@dreryk/react-components';

import { VisitSettlementFormController } from '../VisitSettlementForm';

type PaymentEnabledToggleProps = Pick<VisitSettlementFormController, 'register'>;

export const PaymentEnabledToggle = (props: PaymentEnabledToggleProps): JSX.Element => {
   return <Toggle testId={'paymentEnabled'} controller={props.register('payment.enabled')} />;
};
